import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "5",
  height: "5",
  viewBox: "0 0 5 5"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "2.5",
  cy: "2.5",
  r: "2.5",
  stroke: "none"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "2.5",
  cy: "2.5",
  r: "2",
  fill: "none"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", {
      id: "Ellipse_81",
      "data-name": "Ellipse 81",
      fill: "none",
      stroke: _ctx.color === 0 ? 'red' : 'blue',
      "stroke-width": "1"
    }, _hoisted_5, 8, _hoisted_2)
  ]))
}